import { initialRootState } from '../initialRootState';
import { EConfigurationsActionType, IConfigurationsAction } from './actions';
import { ICaptcha, IFeatureFlipping } from './types';

export interface IConfigurationsState {
  featureFlipping?: IFeatureFlipping;
  captcha?: ICaptcha;
  blackbox?: string;
  baseApiHostname?: string;
}

export const configurationsReducer = (
  currentState: IConfigurationsState = initialRootState.configurations,
  action: IConfigurationsAction
): IConfigurationsState => {
  switch (action.type) {
    case EConfigurationsActionType.GET_SUCCESS:
      return {
        ...currentState,
        captcha: action.payload.captcha,
        featureFlipping: action.payload.featureFlipping,
      };
    case EConfigurationsActionType.GENERATE_BLACKBOX_SUCCESS:
      return {
        ...currentState,
        blackbox: action.payload.blackbox,
      };
    case EConfigurationsActionType.OVERRIDE_BASE_API_URL:
      return {
        ...currentState,
        baseApiHostname: action.payload.baseApiHostname,
      };
    default:
      return currentState;
  }
};
